import { ReactNode, useMemo, useState } from "react";

import { SupportRequestScopeContext } from "@/app/contexts/supportRequestScope";
import { SupportRequestModalContext } from "@/app/entities/SupportRequest";
import { useAuth } from "@/app/hooks/useAuth";
import { SupportRequestModal } from "@/view/components/SupportRequestModal";

interface SupportRequestScopeProviderProps {
  context?: SupportRequestModalContext;
  children: ReactNode;
}

export const SupportRequestScopeProvider = ({
  context,
  children,
}: SupportRequestScopeProviderProps) => {
  const [open, setOpen] = useState(false);
  const { isSuperAdmin, isAdmin, isSupport } = useAuth();

  const value = useMemo(
    () => ({ openSupportRequest: () => setOpen(true) }),
    [],
  );

  const isSupportStaff = isSuperAdmin || isAdmin || isSupport;

  if (isSupportStaff) return <>{children}</>;

  return (
    <SupportRequestScopeContext.Provider value={value}>
      {children}

      <SupportRequestModal
        open={open}
        onOpenChange={setOpen}
        context={context}
      />
    </SupportRequestScopeContext.Provider>
  );
};
